import { CalendarDots } from '@phosphor-icons/react';

export default CalendarDots;
